import React from 'react';
import PropTypes from 'prop-types';
import {
  InputAdornment,
  TextField
} from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

const SearchInput = ({
  className,
  onChange,
  value,
  placeholder = 'Search by patient, MRN, or issue...',
  sx,
  ...rest
}) => {
  return (
    <TextField
      {...rest}
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      variant="outlined"
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon
                sx={{
                  fontSize: 24,
                  color: '#9E9E9E'
                }}
              />
            </InputAdornment>
          )
        }
      }}
      sx={{
        width: 450,

        '& .MuiOutlinedInput-root': {
          height: 50,
          borderRadius: '10px',
          backgroundColor: '#FFFFFF',
          fontSize: 17,
          color: '#616161',
          paddingLeft: '8px',

          '& fieldset': {
            borderColor: '#C7C7C7'
          },

          '&:hover fieldset': {
            borderColor: '#AFAFAF'
          },

          '&.Mui-focused fieldset': {
            borderColor: '#757575',
            borderWidth: '1px'
          }
        },

        '& .MuiInputBase-input': {
          padding: '13px 12px 13px 0',

          '&::placeholder': {
            color: '#666666',
            opacity: 1
          }
        },

        ...sx
      }}
    />
  );
};

SearchInput.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  sx: PropTypes.object
};

export default SearchInput;